export enum PATHS {
  IMPORT_WIZARD = '/importer/',
  CONTACTS_IMPORT_WIZARD = '/contacts/import',
}
